import fetch from 'utils/fetch';

export function taskList(createTimeStart, createTimeEnd, taskNo, status, agent, type, psize, currentPage) {
    const data = {
        createTimeStart,
        createTimeEnd,
        taskNo,
        status,
        agent,
        type,
        psize,
        currentPage
    };
    return fetch({
        url: '/taskList',
        method: 'get',
        params : data
    });
}
export function taskSubmit(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/taskSubmit',
        method: 'post',
        data
    });
}

export function topupList(task_no, status, card_no, product_id, psize, currentPage) {
    const data = {
        task_no,
        status,
        card_no,
        product_id,
        psize,
        currentPage
    };
    return fetch({
        url: '/topupList',
        method: 'get',
        params : data
    });
}

export function errorMsgList(task_no, psize, currentPage) {
    const data = {
        task_no,
        psize,
        currentPage
    };
    return fetch({
        url: '/errorMsgList',
        method: 'get',
        params : data
    });
}

export function retryUpload(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/retryUpload',
        method: 'post',
        data
    });
}






// WEBPACK FOOTER //
// ./src/api/taskTopup.js